import { Routes } from '@angular/router';

export const shipmentsRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./shipments-table/shipments-table.component').then((m) => m.ShipmentsTableComponent),
  },
  {
    path: 'create',
    loadComponent: () => import('./shipments-create/shipments.component').then((m) => m.ShipmentsComponent),
  },
];
